import {Injectable} from '@angular/core';
import {Mutation} from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class DeleteRelayMutation extends Mutation {
  document = gql`
      mutation deleteRelay($id: ID!) {
          deleteRelay(where: {id: $id}) {
              id
          }
      }
  `;
}
